/**
 * API de estimaciones, compartición y comentarios
 */
import client from './client';

export const estimationsApi = {
  // CRUD
  list: (params = {}) =>
    client.get('/estimations', { params }),

  get: (id) =>
    client.get(`/estimations/${id}`),

  create: (data) =>
    client.post('/estimations', data),

  update: (id, data) =>
    client.put(`/estimations/${id}`, data),

  delete: (id) =>
    client.delete(`/estimations/${id}`),

  // Sharing
  getShares: (id) =>
    client.get(`/estimations/${id}/shares`),

  share: (id, userId, permissionLevel) =>
    client.post(`/estimations/${id}/shares`, {
      user_id: userId,
      permission_level: permissionLevel,
    }),

  updateShare: (estimationId, shareId, permissionLevel) =>
    client.put(`/estimations/${estimationId}/shares/${shareId}`, {
      permission_level: permissionLevel,
    }),

  revokeShare: (estimationId, shareId) =>
    client.delete(`/estimations/${estimationId}/shares/${shareId}`),

  // Comments
  getComments: (id) =>
    client.get(`/estimations/${id}/comments`),

  addComment: (id, content) =>
    client.post(`/estimations/${id}/comments`, { content }),
};
